export var TracingSamplingRuleActionTypes;
(function (TracingSamplingRuleActionTypes) {
    TracingSamplingRuleActionTypes["KeepPercentageOfTraces"] = "keepPercentageOfTraces";
    TracingSamplingRuleActionTypes["KeepLatencyThreshold"] = "keepLatencyThreshold";
    TracingSamplingRuleActionTypes["KeepFailed"] = "keepFailed";
})(TracingSamplingRuleActionTypes || (TracingSamplingRuleActionTypes = {}));
export var TracingSamplingRulesSubject;
(function (TracingSamplingRulesSubject) {
    TracingSamplingRulesSubject["Page"] = "tracing-sampling-rules-page";
    TracingSamplingRulesSubject["EmptyState"] = "empty-state";
    TracingSamplingRulesSubject["Modal"] = "tracing-sampling-rule-modals";
    TracingSamplingRulesSubject["Services"] = "services";
    TracingSamplingRulesSubject["AllServices"] = "all-services";
    TracingSamplingRulesSubject["SpecificServices"] = "specific-services";
    TracingSamplingRulesSubject["SelectedServices"] = "selected-services";
    TracingSamplingRulesSubject["Actions"] = "actions";
    TracingSamplingRulesSubject["ProbabilityAction"] = "probability-action";
    TracingSamplingRulesSubject["TraceLatencyAction"] = "trace-latency-action";
    TracingSamplingRulesSubject["SpanErrorAction"] = "span-error-action";
    TracingSamplingRulesSubject["PercentValue"] = "percent-value";
    TracingSamplingRulesSubject["MsValue"] = "ms-value";
    TracingSamplingRulesSubject["UpdateConfigNotification"] = "update-config-notification";
    TracingSamplingRulesSubject["YamlConfigurationPage"] = "yaml-configuration-page";
})(TracingSamplingRulesSubject || (TracingSamplingRulesSubject = {}));
//# sourceMappingURL=tracing-sampling-rules.enum.js.map